export enum FirebaseEnvironment {
  Dev = 'dev',
  Prod = 'prod',
}

export const FIREBASE_ENVIRONMENT = (process.env.REACT_APP_FIREBASE_ENVIRONMENT || 'dev') as FirebaseEnvironment;
